import { render, staticRenderFns } from "./DetalhesProduto.vue?vue&type=template&id=791858bd"
import script from "./DetalhesProduto.vue?vue&type=script&lang=js"
export * from "./DetalhesProduto.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProduto.vue?vue&type=style&index=0&id=791858bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports